import { useRouter } from 'next/dist/client/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import COOKIES from '../../../config/cookies/cookies';
import { SEE_MORE } from '../../../config/text/text';
import { getStaticContent, redirectToURL } from '../../../helpers/url';
import CTAButton from '../../_generic/button/CTAButton';
import DealCarousel from '../dealCarousel/DealCarousel';

const GiftBoxCarousel = ({ guidePageSlug, isTravel }) => {
  const router = useRouter();
  const [deals, setDeals] = useState(null);
  const [guidePageHref, setGuidePageHref] = useState(null);

  useEffect(() => {
    async function fetchGuidePage() {
      const location = Cookies.load(COOKIES.location);
      const userLocation = location?.shortName;
      const pageSize = 20;
      const context = {
        query: {
          slug: guidePageSlug,
        },
      };
      const guidePage = await getStaticContent({
        context,
        pageSize,
        userLocation,
        withDealFeed: true,
      });

      if (guidePage?.props?.deals) {
        setDeals(guidePage.props.deals);
      }
    }
    setGuidePageHref(`/guides/${guidePageSlug}?isClaimMyGift=true`);
    if (guidePageSlug) fetchGuidePage();
  }, [guidePageSlug]);

  const navigate = () => {
    redirectToURL(guidePageHref, router);
  };

  if (!deals || !guidePageSlug) return null;

  return (
    <>
      <div>
        <DealCarousel deals={deals} isTravel={isTravel} />
        {guidePageHref && (
          <div className="button-container">
            <CTAButton
              className="large-border-radius"
              onClick={navigate}
              secondaryButton
            >
              {SEE_MORE}
            </CTAButton>
          </div>
        )}
      </div>
      <style global jsx>{`
        .button-container {
          margin-top: 10px;
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default GiftBoxCarousel;

GiftBoxCarousel.propTypes = {
  guidePageSlug: PropTypes.string,
  isTravel: PropTypes.bool,
};
